/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

// eslint-disable-next-line no-unused-vars
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { useState } from "react";
import baiLogo from "../../../assets/brighter-redact-dark-blue.svg";
// eslint-disable-next-line no-unused-vars
import CloseIcon from "@material-ui/icons/Close";
import { useTheme } from "@material-ui/core/styles";
import * as hotjarUtils from "../../../commons/hotjarUtils";

const useStyles = makeStyles((theme) => ({
  imageLogo: {
    maxHeight: 60,
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.h4.fontSize,
  },
  dialogContent: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  secondText: {
    fontSize: 10,
    color: theme.palette.primary.contrastText,
    maxWidth: 50,
    margin: 0,
  },
  dialogActions: {
    justifyContent: "center",
    paddingTop: 0,
  },
  button: {
    padding: 0,
    maxWidth: 33,
    maxHeight: 33,
    minWidth: 33,
    minHeight: 33,
    margin: theme.spacing(1),
    fontSize: theme.typography.h3.fontSize,
  },
  dialog: {
    padding: theme.spacing(5),
    height: 240,
    width: 600,
  },
  dialogTitle: {
    padding: 0,
    textAlign: "center",
  },
  closeButton: {
    cursor: "pointer",
    float: "right",
    padding: 0,
  },
}));

function VotingButton({ votingValue, setIsVoted }) {
  const classes = useStyles();
  const [bgColor, setBgColor] = useState("white");
  const theme = useTheme();

  function onClick(event) {
    setBgColor(theme.palette.primary.main);

    hotjarUtils.voteAndSubmit(event.currentTarget.value);
    setTimeout(() => {
      setIsVoted(true);
    }, 500);
  }

  return (
    <Button
      variant="outlined"
      className={classes.button}
      value={votingValue}
      onClick={onClick}
      style={{ backgroundColor: bgColor }}
    >
      {votingValue}
    </Button>
  );
}

export function Voting({ open, setIsVoted, onClose }) {
  const classes = useStyles();

  const votingNumbers = [...Array(11).keys()];
  function getVotingButtons() {
    return votingNumbers.map((number) => {
      return (
        <VotingButton
          key={"voting-button-" + number}
          votingValue={number}
          setIsVoted={setIsVoted}
        />
      );
    });
  }

  return (
    <Dialog open={open} keepMounted classes={{ paper: classes.dialog }}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <img
          src={baiLogo}
          alt="brighter redact logo"
          className={classes.imageLogo}
        />
        <IconButton
          onClick={onClose}
          className={classes.closeButton}
          data-testid="voting-close-button"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.text}>
          How likely are you to recommend brighter Redact to a friend?
        </DialogContentText>
      </DialogContent>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText
          className={classes.secondText}
          style={{ float: "left" }}
        >
          Not likely
        </DialogContentText>
        <DialogContentText
          className={classes.secondText}
          style={{ float: "right" }}
        >
          Very likely
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {getVotingButtons()}
      </DialogActions>
    </Dialog>
  );
}
